export type SelectOption = { label: string; value: string; group?: string };

export function groupSelectOptions(options: SelectOption[]): {
  ungrouped: SelectOption[];
  groups: { group: string; options: SelectOption[] }[];
} {
  const ungrouped: SelectOption[] = [];
  const byGroup = new Map<string, SelectOption[]>();
  for (const option of options) {
    if (!option.group) {
      ungrouped.push(option);
      continue;
    }
    const bucket = byGroup.get(option.group);
    if (bucket) {
      bucket.push(option);
    } else {
      byGroup.set(option.group, [option]);
    }
  }
  const groups = [...byGroup.entries()].map(([group, groupOptions]) => ({
    group,
    options: groupOptions,
  }));
  return { ungrouped, groups };
}

export function renderSelectOptions(options: SelectOption[]) {
  const renderOption = (option: SelectOption) => (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
  );
  const { ungrouped, groups } = groupSelectOptions(options);
  return (
    <>
      {ungrouped.map(renderOption)}
      {groups.map((entry) => (
        <optgroup key={entry.group} label={entry.group}>
          {entry.options.map(renderOption)}
        </optgroup>
      ))}
    </>
  );
}
